import React from 'react'
import { FilterDot, FilterTab, FilterTabsList, FilterTabText } from './Theme'

const FilterTabs = ({
  tabs,
  activeTab,
  onTabsChange,
  className,
  style = {},
  tabTextWeight,
}) => {
  return (
    <FilterTabsList className={className} style={style}>
      {tabs?.map(tab => (
        <FilterTab
          key={tab?.value}
          active={tab?.value?.toLowerCase() === activeTab?.toLowerCase()}
          onClick={() => onTabsChange(tab)}
        >
          {tab?.dotColor && <FilterDot color={tab?.dotColor} />}
          <FilterTabText weight={tabTextWeight}>{tab?.title}</FilterTabText>
        </FilterTab>
      ))}
    </FilterTabsList>
  )
}

export default FilterTabs